/* eslint-disable */
import React from 'react';
import { Chip, Box } from '@mui/material';

/**
 * STATUS_MAP — extend this object to add new statuses.
 * Each entry: { label, color, bg, border }
 */
export const STATUS_MAP = {
  // Orders
  EN_COURS:        { label: 'En cours de traitement', color: '#FEA26F', bg: '#FEA26F17', border: '#FEA26F' },
  ENVOYEE:         { label: 'Envoyée',                color: '#027BC6', bg: '#027BC614', border: '#027BC6' },
  TRAITEE:         { label: 'Traitée',                color: '#0AD69F', bg: '#0AD69F1D', border: '#00D69F' },
  ANNULEE:         { label: 'Annulée',                color: '#DC2626', bg: '#FEE2E2', border: '#FCA5A5' },
  // Invoices
  REGLE:           { label: 'Réglée',                 color: '#0AD69F', bg: '#0AD69F1D', border: '#00D69F' },
  NON_REGLE:       { label: 'Non Réglée',             color: '#8398AE', bg: '#949FB800', border: '#8398AE' },
  NON_REGLE_ECHUE: { label: 'Non Réglée échue',       color: '#1F2937', bg: '#1F293812', border: '#1F2937' },
  PARTIELLEMNT_REGLE:{ label: 'Partiellement Réglée', color: '#FEA26F', bg: '#FEA27005', border: '#FEA26F' },
  PAYE:              { label: 'Payé',                  color: '#0AD69F', bg: '#0AD69F1D', border: '#00D69F' },
  NON_PAYE:          { label: 'Impayé',              color: '#EF446E', bg: '#EF446E10', border: '#EF446E' },
  // Announcements
  NOUVEAUTE:       { label: 'Nouveauté',              color: '#15803D', bg: '#DCFCE7', border: '#86EFAC' },
  PROMOTION:       { label: 'Promotion',              color: '#B45309', bg: '#FEF3C7', border: '#FCD34D' },
  INFORMATION:     { label: 'Information',            color: '#0369A1', bg: '#E0F2FE', border: '#7DD3FC' },
  EVENT:           { label: 'Évènement',              color: '#6D28D9', bg: '#EDE9FE', border: '#C4B5FD' },
  // Users
  ACTIVE:          { label: 'Actif',                  color: '#15803D', bg: '#DCFCE7', border: '#86EFAC' },
  INACTIVE:        { label: 'Inactif',                color: '#6B7280', bg: '#F3F4F6', border: '#D1D5DB' },
  BLOCKED:         { label: 'Bloqué',                 color: '#DC2626', bg: '#FEE2E2', border: '#FCA5A5' },
};

const FALLBACK = { label: '', color: '#374151', bg: '#F9FAFB', border: '#E5E7EB' };

const MF_LABEL_MAP = {
  REGLE: 'Validé',
  NON_REGLE: 'Non validé',
  NON_REGLE_ECHUE: 'Expiré',
  PARTIELLEMNT_REGLE: 'Partiel',
  NON_PAYE: 'Rejeté',
};

// Map French backend labels to STATUS_MAP keys
const LABEL_TO_KEY = {
  'réglée': 'REGLE',
  'non réglée': 'NON_REGLE',
  'non réglée échue': 'NON_REGLE_ECHUE',
  'partiellement réglée': 'PARTIELLEMNT_REGLE',
  'impayée': 'NON_PAYE',
  // Orders — French labels returned by API
  'envoyée': 'ENVOYEE',
  'en cours de traitement': 'EN_COURS',
  'traitée': 'TRAITEE',
};

const resolveStatus = (status) => {
  if (!status) return FALLBACK;
  // Try direct key match
  const upper = status.toUpperCase();
  if (STATUS_MAP[upper]) return STATUS_MAP[upper];
  // Try French label match
  const lower = status.toLowerCase().trim();
  const key = LABEL_TO_KEY[lower];
  if (key && STATUS_MAP[key]) return STATUS_MAP[key];
  return FALLBACK;
};

/**
 * StatusBadge — reusable status chip.
 *
 * Usage:
 *   import StatusBadge from 'Shared/StatusBadge';
 *   <StatusBadge status="TRAITEE" />
 *   <StatusBadge status="REGLE" label="Payée" />   // override label
 *
 * Props:
 *   status  {string}  — key from STATUS_MAP (case-insensitive)
 *   label   {string}  — optional override for display text
 *   size    {string}  — "small" | "medium"  (default "small")
 *   sx      {object}  — extra MUI sx overrides
 */
const StatusBadge = ({ status = '', label, isMF = false, size = 'small', sx = {} }) => {
  const cfg = resolveStatus(status);
  const upper = status?.toUpperCase();
  const lower = status?.toLowerCase().trim();
  const resolvedKey = LABEL_TO_KEY[lower] || upper;
  const displayLabel = label || (isMF && MF_LABEL_MAP[resolvedKey]) || cfg.label || status;

  return (
    <Chip
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 }} />
          {displayLabel}
        </Box>
      }
      size={size}
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.border}`,
        borderRadius: '20px',
        fontWeight: 600,
        fontSize: '12px',
        height: '24px',
        '& .MuiChip-label': { px: '10px' },
        ...sx,
      }}
    />
  );
};

export default StatusBadge;
